import React from 'react';

function RadioButton({ id, name, value, label, onChange, checked }) {
  return (
    <div className="form-check">
      <input
        type="radio"
        className="form-check-input fs-4"
        id={id}
        name={name}
        value={value}
        checked={checked} 
        onChange={onChange}
      />
      <label className="form-check-label fs-4" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

export default RadioButton;
